import React, { useRef, useEffect } from "react";

function ShopPay() {
  const ref = useRef(null);

  useEffect(() => {
    const reRenderCartForm = () => {
      fetch("/cart", { cache: "default" })
        .then((response) => response.text())
        .then(async (data) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, "text/html");
          const formSelector = doc.querySelector("#mini-cart-cart-form form[action='/cart']");
          const cartForm = document.querySelector("#mini-cart-cart-form form[action='/cart']");
          cartForm.innerHTML = formSelector.innerHTML;
          await ref.current.appendChild(cartForm.cloneNode(true));
          setTimeout(() => ref.current.classList.add("loaded"), 500);
        });
    };

    const shopPayEl = document.querySelector("#cart_form shopify-payment-terms");

    if (!shopPayEl) {
      reRenderCartForm();
      return;
    }

    ref.current.appendChild(shopPayEl.cloneNode(true));
    ref.current.classList.add("loaded");
  }, []);

  return <div className="minicart__shoppay" ref={ref}></div>;
}

export default ShopPay;
